// @flow
export const FilterByAllowedFields: Function = (obj: Dict, allowed: string[]) => {
  return Object.keys(obj)
    .filter((fld) => allowed.includes(fld))
    .reduce((ob, fld) => {
      ob[fld] = obj[fld];
      return ob;
    }, {});
};
